module.exports = __webpack_public_path__ + "img/Ghost.9f87bbdd.png";